import { Box } from "@mui/material";
import { BOM_STAGES } from "assets/constants/Constants";
import { DELIVERY_STATUS } from "assets/constants/Constants";
import BomProgressBar from "views/BOM/BomProgressBar";

    const fieldsToShow = [
        { key: 'customerName', label: 'Customer' },
        { key: 'po_reference', label: 'PO Reference' },
        { key: 'businessVerticalName', label: 'Business Vertical' },
        { key: 'regionName', label: 'Region' },
        { key: 'documentNumber', label: 'Fixture Document Number' },
        { key: 'component_drawing_numbers', label: 'Component Drawing Number(s)' },
        { key: 'fixtureName', label: 'Fixture Name' },
        { key: 'surface_treatment_type', label: 'Surface Treatment Type' },
        { key: 'machine', label: 'Machine' },
        { key: 'designEngineerName', label: 'Design Engineer' },
        { key: 'dapDate', label: 'DAP Date' },
        { key: 'manufacturing_release_date', label: 'Manufacturing Release Date' },
    ];

    const dispatch_details = [
        { key: 'dispatch_via', label: 'Dispatch Via' },
        { key: 'awb_number', label: 'AWB Number' },
        { key: 'mode_of_dispatch', label: 'Mode of Dispatch' },
        { key: 'dispatch_date', label: 'Dispatch Date' }
    ]

function BOMViewModal(handleClose, selectedRowData) {
    return <div className="custom_modal" onClick={handleClose}>
        <div className="modal_body" onClick={(e) => e.stopPropagation()}>
            <button
                type="button"
                className="close text-right"
                style={{ fontSize: '2.5rem' }}
                onClick={handleClose}
            >
                &times;
            </button>
            <h4>BOM Details</h4>
            <hr />
            <Box
                sx={{
                    '& .MuiStepLabel-label': {
                        fontWeight: '400 !important',
                        fontSize: '12px !important'
                    },
                    '& .MuiStepLabel-label.Mui-active': {
                        fontWeight: '600 !important'
                    }
                }}
            >
                <BomProgressBar 
                        currentStage={selectedRowData.current_stage} 
                        stageTimelines={selectedRowData.stage_timelines} 
                />
            </Box>
            <hr />
            {selectedRowData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION && (
                <>
                    {(() => {
                        const status = selectedRowData.current_tracking_status || '-';
                        let statusClass = 'status-default';
                        if (status === DELIVERY_STATUS.ON_TIME) statusClass = 'status-on-time';
                        else if (status === DELIVERY_STATUS.WARNING) statusClass = 'status-warning';
                        else if (status === DELIVERY_STATUS.DELAYED) statusClass = 'status-delayed';
                        else if (status === DELIVERY_STATUS.PENDING) statusClass = 'status-pending';
                        else if (status === DELIVERY_STATUS.PAUSED) statusClass = 'status-paused';

                        return (
                            <>
                                <div className="detail_row" style={{borderBottom:0}}>
                                    <div className="detail_label_progress">Fixture Progress:</div>
                                    <div className="detail_value_progress">
                                        <div className="progress-bar-container">
                                            <div
                                                className={`progress-bar ${statusClass}`}
                                                style={{ width: `${selectedRowData.completion_percentage || 0}%` }}
                                            >
                                                {selectedRowData.completion_percentage || 0}%
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="detail_row"  style={{borderBottom:0, marginBottom:5}}>
                                    <div className="detail_label_progress">Tracking Status:</div>
                                    <div className="detail_value_progress">
                                        <span className={`status-badge ${statusClass}`}>{status}</span>
                                    </div>
                                </div>
                            </>
                        );
                    })()}
                </>
            )}
            <div className="modal_content">
                {fieldsToShow.map(({ key, label }) => {
                    const value = selectedRowData[key];
                    let displayValue = Array.isArray(value)
                        ? (value.length > 0 ? value.join(', ') : '-')
                        : (value || '-');

                    return (
                        <div key={key} className="detail_row">
                            <div className="detail_label">{label}:</div>
                            <div className="detail_value">{displayValue}</div>
                        </div>
                    );
                })}
            </div>

            {(selectedRowData.current_stage === BOM_STAGES.VALIDATION || selectedRowData.current_stage === BOM_STAGES.COMPLETED || selectedRowData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH)  && (
                <>
                <div className="detail_label">Dispatch Details:</div>
                <hr />
                <div className="modal_content">
                    {dispatch_details.map(({ key, label }) => {
                        let value = selectedRowData?.dispatch_details ? selectedRowData.dispatch_details[key] : undefined;
                    
                    if (key === 'dispatch_date' && value) {
                        const dateVal = value.$date ? value.$date : value;
                        value = new Date(dateVal).toLocaleDateString();
                        if (value === 'Invalid Date') value = '-';
                    }

                    let displayValue = Array.isArray(value)
                        ? (value.length > 0 ? value.join(', ') : '-')
                        : (value || '-');

                    return (
                        <div key={key} className="detail_row">
                            <div className="detail_label">{label}:</div>
                            <div className="detail_value">{displayValue}</div>
                        </div>
                    );
                })}
            </div>
            </>
        )}
        </div>
    </div>;
}

export default BOMViewModal;